import { CHARACTERS, WAVE_COUNT, waveByIndex } from "@roguelik/shared-sim";
import { net, selectedCharacter } from "../store.js";
import { fmtClock } from "../theme.js";

/** Top run strip: level + XP bar + wave progress (or FINAL BOSS). Hidden in the lobby. */
export function RunStrip() {
  const n = net.value;
  if (n === null || n.runPhase === "lobby") return null;
  const frac = n.xpToNext > 0 ? Math.max(0, Math.min(1, n.xp / n.xpToNext)) : 0;
  const boss = n.runPhase === "boss";
  const inLull = n.waveLullMs > 0;
  const char = CHARACTERS.find((c) => c.id === selectedCharacter.value);
  const ability = char?.ability ?? "none";
  const abilityReady = n.abilityCdPct === 0;
  return (
    <div class="absolute top-2.5 left-1/2 -translate-x-1/2 flex items-center gap-3 rounded-lg border border-edge bg-panel/80 px-3 py-1.5 backdrop-blur-sm">
      <span class="font-bold tabular-nums">Lv {n.level}</span>
      {n.loopIndex > 0 && (
        <span
          class="rounded bg-fuchsia-500/25 px-1.5 font-bold text-fuchsia-200"
          title="Endless loop"
        >
          Loop {n.loopIndex}
        </span>
      )}
      <div class="relative h-3 w-56 overflow-hidden rounded-sm border border-edge bg-[#161b2a]">
        <div
          class="absolute inset-y-0 left-0 bg-sky-300 transition-[width] duration-200"
          style={{ width: `${frac * 100}%` }}
        />
      </div>
      <span class="tabular-nums">{boss ? "FINAL BOSS" : fmtClock(n.runClockMs)}</span>
      {!boss &&
        (inLull ? (
          <span class="font-semibold text-amber-300">
            Next wave in {Math.ceil(n.waveLullMs / 1000)}s
          </span>
        ) : (
          <span class="opacity-80">
            Wave {n.waveIndex + 1}/{WAVE_COUNT} · {waveByIndex(n.waveIndex).name}
          </span>
        ))}
      {ability !== "none" && (
        <span
          class={`rounded px-1.5 font-semibold uppercase tracking-wide ${
            abilityReady ? "bg-cyan-400/30 text-cyan-100" : "bg-white/5 text-white/40"
          }`}
          title="Active ability — press Space"
        >
          ⚡ {ability} {abilityReady ? "·READY" : `·${Math.ceil((n.abilityCdPct / 255) * 100)}%`}
        </span>
      )}
    </div>
  );
}
